import { useState } from 'react';
import { OptionalKeysDeep } from '@mews/std';
import { InfinityType, PAGINATION_SIZES, TableFilters, TableState } from '../types';

export const POSITIVE_INFINITY = Number.POSITIVE_INFINITY as InfinityType;

export const useTableState = <T, F extends TableFilters<T> = TableFilters<T>>({
    pagination,
    ...overrides
}: OptionalKeysDeep<TableState<T, F>, 'pagination'> = {}) =>
    useState<TableState<T, F>>({
        pagination: {
            pageIndex: pagination?.pageIndex ?? 0,
            show: pagination?.show ?? true,
            pageSize: pagination?.show !== false ? pagination?.pageSize || PAGINATION_SIZES[25] : POSITIVE_INFINITY,
        },
        filters: {} as F,
        globalFilters: {},
        sort: {},
        expanded: {},
        grouping: [],
        ...overrides,
    });
